const schoolConstants = {
  zmailtest: {
    UserPoolId: 'us-east-1_DcPPSNN62',
    ClientId: '6hlse621m0me8oupi1kb6qe7v3',
    IdentityPoolId: 'us-east-1:41dbc5be-da0b-4fca-95ee-8e0ad2036425',
    Login: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_DcPPSNN62',
    masterTable: 'masterPlayers',
  },
  Zcruitest: {
    UserPoolId: 'us-east-1_2pX3YGDVK',
    ClientId: '49qbmr1gsqr5f52emk2h54rb1l',
    IdentityPoolId: 'us-east-1:5fdce1d4-f89c-45c3-8374-3da1d87d8d0b',
    Login: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_2pX3YGDVK',
    masterTable: 'masterPlayers',
  },
  Wake: {
    UserPoolId: 'us-east-1_2pX3YGDVK',
    ClientId: '49qbmr1gsqr5f52emk2h54rb1l',
    IdentityPoolId: 'us-east-1:5fdce1d4-f89c-45c3-8374-3da1d87d8d0b',
    Login: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_2pX3YGDVK',
    masterTable: 'masterPlayers',
  },
  Northwestern: {
    UserPoolId: 'us-east-1_714aPTFu7',
    ClientId: '8nv0f7d79dgh1u12ve0hha0lb',
    IdentityPoolId: 'us-east-1:f2fb310f-f60e-4b5f-8f78-3ff210ef6bbe',
    Login: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_714aPTFu7',
  },
  'Old Dominion': {
    UserPoolId: 'us-east-1_vDsofrOAN',
    ClientId: '7v4fpeiie4lchvluh1fpb84dkn',
    IdentityPoolId: 'us-east-1:df5a72c7-3ead-44e7-9272-84d3f8c9107f',
    Login: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_vDsofrOAN',
  },
  'Wake Forest': {
    UserPoolId: 'us-east-1_nPvcYAT0s',
    ClientId: '3i8t86alrld0dt3k2fda754obm',
    IdentityPoolId: 'us-east-1:f3596ce1-0e7a-4121-9965-4b43634c4a35',
    Login: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_nPvcYAT0s',
  },
  Dartmouth: {
    UserPoolId: 'us-east-1_ix3jDYQHG',
    ClientId: '76pefe2e56s8uan29rvua163o8',
    IdentityPoolId: 'us-east-1:b7b4bfad-1b09-4a54-bd76-b373538a751d',
    Login: 'cognito-idp:us-east-1:342496933485:userpool/us-east-1_ix3jDYQHG',
  },
  Kansas: {
    UserPoolId: 'us-east-1_V9DTdaAT1',
    ClientId: '6unnspfisj95opv3qdogg3ss1p',
    IdentityPoolId: 'us-east-1:ba127200-83d0-4719-80d8-90779c6f2ead',
    Login: 'cognito-idp:us-east-1:342496933485:userpool/us-east-1_V9DTdaAT1',
  },
  Clemson: {
    UserPoolId: 'us-east-1_4soP1o8oP',
    ClientId: '638l0m2uk3c3851u0ibbmb0c52',
    IdentityPoolId: 'us-east-1:b874cb16-35d5-4f2b-9caf-7e20318dc684',
    Login: 'cognito-idp:us-east-1:342496933485:userpool/us-east-1_4soP1o8oP',
  },
  Columbia: {
    UserPoolId: 'us-east-1_RwBDppZMM',
    ClientId: '79gghmt6abm989co9vnclou26i',
    IdentityPoolId: 'us-east-1:97762ae1-a831-42d0-bad2-2392f0bd85b8',
    Login: 'cognito-idp:us-east-1:342496933485:userpool/us-east-1_RwBDppZMM',
  },
  Princeton: {
    UserPoolId: 'us-east-1_jLO8grxnc',
    ClientId: '3coje339du6jngntch5fntmnns',
    IdentityPoolId: 'us-east-1:1cbe8824-daca-4656-b9d4-09a490d8cdb2',
    Login: 'arn:aws:cognito-idp:us-east-1:342496933485:userpool/us-east-1_jLO8grxnc',
  },
  Liberty: {
    UserPoolId: 'us-east-1_AhdW9iesu',
    ClientId: '6i847hcqhinbcn411pu57221j',
    IdentityPoolId: 'us-east-1:b25dd3ec-5008-41cc-b3fa-851cd408b699',
    Login: 'arn:aws:cognito-idp:us-east-1:342496933485:userpool/us-east-1_AhdW9iesu',
  },
  Colorado: {
    UserPoolId: 'us-east-1_Hoy1asnMl',
    ClientId: '5jkugkjbie6erm057nffh3ob2n',
    IdentityPoolId: 'us-east-1:dbcda267-016e-484c-872e-ee273cfd1209',
    Login: 'arn:aws:cognito-idp:us-east-1:342496933485:userpool/us-east-1_Hoy1asnMl',
  },
  ZcruitLiteTest: {
    UserPoolId: 'us-east-1_YeNJRkiP9',
    ClientId: '5iunk0iue4bro76q855dhkp9un',
    IdentityPoolId: 'us-east-1:a1b015ad-fdbe-46eb-a027-38921076b436',
    Login: 'arn:aws:cognito-idp:us-east-1:342496933485:userpool/us-east-1_YeNJRkiP9',
  },
  Pittsburgh: {
    UserPoolId: 'us-east-1_A5HV00lH7',
    ClientId: 'df95p5viiat7vhh1l7079hh8r',
    IdentityPoolId: 'us-east-1:24f9a6a9-7981-4f17-957d-c453af592f9e',
    Login: 'arn:aws:cognito-idp:us-east-1:342496933485:userpool/us-east-1_A5HV00lH7',
  },
};

export default schoolConstants;



// WEBPACK FOOTER //
// ./src/constants/schoolConstants.js